import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import "rxjs/add/observable/of";
import {ISelection} from "../../api/data-model";
import {UtilitiesService} from "../utilities.service";
import {ResetSelectionLoadedEvent} from "../../event/ContentEvents";
import {EventBus} from "../../event/EventBus";
import {PipelineService} from "../pipeline/pipeline.service";
import {ClientConfiguration} from "../configuration/client.config";
import {ICredit} from "../../api/data-model";
import {RaVersion} from "../configuration/ra.version";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {of} from "rxjs/internal/observable/of";

export interface IImageCredit {
    word: string;
    description: string;
    attribution: string;
}

@Injectable()
export class ContentService {

    private currentContent: ISelection;
    private contentCache:Map<string, ISelection> = <Map<string, ISelection>> new Map();

    constructor(private http:HttpClient, private eventBus: EventBus, private clientConfiguration: ClientConfiguration ) {
    }

    /**
     * Retrieves Selection from local cache or content server
     */
    public retrieveSelection(name:string, isPipeline?:boolean):Observable<ISelection> {
        let getOptions:any = {};
        if (isPipeline) {
            name = name + "-source";
            getOptions = { withCredentials: true };
        }
        if (this.contentCache.has(name) && !isPipeline) {
            this.currentContent = this.contentCache.get(name);
            return of(this.currentContent);
        } else {
            let contentURL = isPipeline ? PipelineService.CONTENT_SELECTIONS + name + ".json" +
                                          UtilitiesService.cacheBuster("&")
                : this.clientConfiguration.contentUrl + "/" + name + ".json" + RaVersion.full;
            console.log("Retrieving selection from contentURL=", contentURL);


            return this.http.get(contentURL, getOptions)
                .pipe(map(data => {
                    console.log("Returned from retrieving selection.", data);
                    const dataVal:any = data;
                    this.contentCache.set(name, dataVal);
                    this.currentContent = dataVal;
                    this.eventBus.next(new ResetSelectionLoadedEvent());
                    return this.contentCache.get(name);
                }));



        }
    }

    public getStoryTitleCredits(): string {
        return this.currentContent.metaData.fullTitle;
    }

    public getStoryCredits(): ICredit[] {
        return this.currentContent.metaData.credits;
    }

    public getImageCredits(): IImageCredit[] {
        let imageCredits = [];
        for (let key of Object.keys(this.currentContent.glossaryEntries)) {
            let glossary = this.currentContent.glossaryEntries[key];
            if (!!glossary.imageCredits && glossary.imageCredits.length !== 0) {
                let imageCredit = glossary.imageCredits[0];
                imageCredits.push({
                    "word": glossary.word,
                    "description": imageCredit.description,
                    "attribution": imageCredit.attribution
                });
            } else {
                let mediaString = glossary.context.media;
                if ( mediaString.indexOf("shutterstock") >= 0) {
                    imageCredits.push({
                        "word": glossary.word,
                        "description": "",
                        "attribution": "Used by permission from Shutterstock"
                    });
                }
            }
        }
        return imageCredits;
    }

}
